var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showModal),expression:"showModal"}],ref:"modalDom",staticClass:"modal-wrapper"},[(_vm.needModal)?_c('div',{staticClass:"overlay",style:(_vm.modalStyle),on:{"click":_vm.hideMask}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }